import type { ApiPurchaseQuotePayload } from '@lgc/database/types/domains/subscription';

export interface LessonQuoteDiscount {
  label: string;
  /** Positive dollars off. @unit dollars */
  amount: number;
}

/**
 * The member-discount row of a lesson purchase quote, or null when none applies.
 * The amount is the server's `totals.discountTotal`; the label is the quote's
 * `discount` line title. Nothing is computed here.
 */
export function lessonQuoteDiscount(
  quote: Pick<ApiPurchaseQuotePayload, 'lineItems' | 'totals'> | undefined,
): LessonQuoteDiscount | null {
  const amount = quote?.totals?.discountTotal ?? 0;
  if (amount <= 0) return null;
  const label = quote?.lineItems?.find((line) => line.key === 'discount')?.label;
  return { label: label ?? 'Member discount', amount };
}
